import React from 'react';
import PropTypes from 'prop-types';

import InfoIcon from './info-icon.svg';
import CloseIcon from 'Static/icons/close-x.svg';
import ReminderIcon from './reminder.svg';
import styles from './Tooltip.scss';

class Tooltip extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: false,
    };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    const clickedTheBubble = e.target.classList.contains('Tooltip__bubble');
    const clickedTheIcon = e.target.classList.contains('Tooltip__icon');
    if (clickedTheIcon) return;
    if (!clickedTheBubble && this.state.visible) {
      this.setState({ visible: false });
    }
  }

  componentDidMount() {
    window.addEventListener('click', this.handleClick, false);
    if (this.props.fadeIn) {
      window.setTimeout(() => {
        this.setState({ visible: true });
      }, 3000);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.handleClick);
  }

  render() {
    const { header, body, id } = this.props;
    return (
      <div
        className={`Tooltip is-${
          this.state.visible ? 'visible' : 'hidden'
        } Tooltip--${id}`}
      >
        <InfoIcon
          className="Tooltip__icon"
          onClick={e => this.setState({ visible: !this.state.visible })}
        />
        <div className="Tooltip__bubble">
          <CloseIcon
            className="Tooltip__close"
            onClick={e => this.setState({ visible: false })}
          />
          <ReminderIcon className="Tooltip__reminder-icon" />
          <div className="Tooltip__content">
            <h4 className="Tooltip__header">{header}</h4>
            {body ? <p className="Tooltip__body">{body}</p> : null}
          </div>
        </div>
      </div>
    );
  }
}

Tooltip.defaultProps = {
  fadeIn: false,
};

Tooltip.propTypes = {
  /** This is large! Ideally, it should be 20-30 characters. */
  header: PropTypes.node.isRequired,
  /** This is small! It is a paragrah, but shouldn’t be more than 2-3 lines */
  body: PropTypes.node,
  /**
   * If set to true, the tooltip will fade in, stay visible for 3 seconds,
   * then fade out again.
   */
  fadeIn: PropTypes.bool,
  /** This is just used as a CSS class */
  id: PropTypes.string.isRequired,
};

export default Tooltip;
